import { useRef, useCallback, useState, useEffect } from 'react';

export const useNotificationSound = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [soundEnabled, setSoundEnabled] = useState(() => {
    return localStorage.getItem('chatSoundEnabled') !== 'false';
  });

  useEffect(() => {
    // Inicializar el audio
    if (!audioRef.current) {
      audioRef.current = new Audio('/notification-sound.mp3');
    }
  }, []);

  const playNotification = useCallback(() => {
    if (!soundEnabled || !audioRef.current) return;
    
    // Reiniciar el audio si ya estaba reproduciéndose
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(error => {
      console.error('Error playing notification sound:', error);
    });
  }, [soundEnabled]);

  const toggleSound = useCallback(() => {
    const newValue = !soundEnabled;
    setSoundEnabled(newValue);
    localStorage.setItem('chatSoundEnabled', String(newValue));
  }, [soundEnabled]);

  return { playNotification, soundEnabled, toggleSound };
};
